import * as React from 'react';
import { cn } from '@common/bw-ui/lib/utils';

export interface BookingSummarySkeletonProps {
  className?: string;
}

function SkeletonBar({ className }: { className?: string }) {
  return (
    <div
      className={cn('tw:animate-pulse tw:rounded-md tw:bg-black/10', className)}
    />
  );
}

function SkeletonRow({
  labelWidth,
  valueWidth,
}: {
  labelWidth: string;
  valueWidth: string;
}) {
  return (
    <div className="tw:flex tw:justify-between tw:items-center">
      <SkeletonBar className={cn('tw:h-4', labelWidth)} />
      <SkeletonBar className={cn('tw:h-4', valueWidth)} />
    </div>
  );
}

export function BookingSummarySkeleton({
  className,
}: BookingSummarySkeletonProps) {
  return (
    <div
      data-testid="booking-summary-skeleton"
      className={cn(
        'tw:flex tw:flex-col tw:gap-5 tw:rounded-lg tw:bg-white tw:p-6 tw:shadow-md',
        className,
      )}
    >
      {/* Heading */}
      <SkeletonBar className="tw:h-6 tw:w-40" />

      {/* Discount code input placeholder */}
      <SkeletonBar className="tw:h-10 tw:w-full tw:rounded-md" />

      <div className="tw:h-px tw:bg-black/10" />

      {/* Totals */}
      <div className="tw:flex tw:flex-col tw:gap-3">
        <SkeletonRow labelWidth="tw:w-16" valueWidth="tw:w-14" />
        <SkeletonRow labelWidth="tw:w-8" valueWidth="tw:w-14" />

        <div className="tw:h-px tw:bg-black/10" />

        {/* Total row — larger */}
        <div className="tw:flex tw:justify-between tw:items-center">
          <SkeletonBar className="tw:h-5 tw:w-24" />
          <SkeletonBar className="tw:h-7 tw:w-20" />
        </div>
      </div>

      {/* Proceed button */}
      <SkeletonBar className="tw:h-10 tw:w-full tw:rounded-md" />

      {/* Cancellation notice */}
      <div className="tw:flex tw:gap-3 tw:rounded-lg tw:border tw:border-black/5 tw:bg-black/[0.02] tw:p-4">
        <SkeletonBar className="tw:w-5 tw:h-5 tw:rounded-full tw:shrink-0" />
        <div className="tw:flex tw:flex-col tw:gap-1 tw:flex-1">
          <SkeletonBar className="tw:h-4 tw:w-28" />
          <SkeletonBar className="tw:h-3 tw:w-full" />
        </div>
      </div>
    </div>
  );
}
